import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalModule } from '../../global.module';

import { TooltipModule } from '../tooltip/tooltip.module';
import { ShipmentStateIndicatorCirclesComponent } from './shipment-state-indicator-circles.component';

@NgModule({
  imports: [GlobalModule, TranslateModule, TooltipModule, ShipmentStateIndicatorCirclesComponent],
  exports: [ShipmentStateIndicatorCirclesComponent],
})
export class ShipmentStateIndicatorCirclesModule {}
